export default __webpack_public_path__ + "static/media/4.0e1eacd4.png";